import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoStatusCardComponent } from './logo-status-card.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [LogoStatusCardComponent],
  imports: [CommonModule, SvgIconModule, NgbModule],
  exports: [LogoStatusCardComponent],
})
export class LogoStatusCardModule {}
